import { useContext, useEffect, useState } from "react";
import { ProcessContext } from "../../../../../../../contexts/ProcessContext";
import { useLoanCalculatorBase } from "./useLoanCalculatorBase";
import { useActionCallback } from "../../../../../../../utils/hooks/useActionCallback";

export const useLoanCalculator = () => {
  const {
    state: { loan, pricingByLoanId, loanCalculator },
    dispatch,
  } = useContext(ProcessContext);

  const {
    loanConditions,
    setLoanConditionsByTerm,
    patchSetLoanCalculator,
    setLoanConditions,
    termMarks,
    minTerm,
    maxTerm,
    getMerchantDiscountByPricing,
  } = useLoanCalculatorBase();
  const [loadingLoanCalculators, setLoadingLoanCalculators] = useState(false);

  const getLoanCalculator = () => {
    setLoadingLoanCalculators(true);
    dispatch({
      type: "REQUEST_GET_AVAILABLE_LOAN_CALCULATORS",
      payload: loan.id,
    });
  };

  useActionCallback("REQUEST_GET_AVAILABLE_LOAN_CALCULATORS_FULFILLED", () => {
    setLoadingLoanCalculators(false);
  });

  useEffect(() => {
    if (!pricingByLoanId) return;

    const merchantDiscount = getMerchantDiscountByPricing();
    setLoanConditions({
      ...loanConditions,
      ranges: pricingByLoanId.ranges,
      merchantDiscountPercentage: merchantDiscount,
    });

    if (!loanCalculator) {
      getLoanCalculator();
    }
  }, [pricingByLoanId]);

  return {
    loadingLoanCalculators,
    loanConditions,
    setLoanConditionsByTerm,
    patchSetLoanCalculator,
    setLoanConditions,
    termMarks,
    minTerm,
    maxTerm,
  };
};
